import React, { useState } from 'react';
import './SearchBarFilter.scss';
import SearchBar from '../SearchBar';
import Button from '../Button';

type Props = {
  onSearch?: (arg: string) => void;
  term?: string;
};
const SearchBarFilter = (props: Props) => {
  const [value, setValue] = useState(props.term || '');
  const onChange = (arg: string) => {
    setValue(arg);
  };
  const onSubmit = () => {
    if (value.length > 1) {
      props.onSearch?.(value);
    }
  };
  return (
    <div className="row search-filter">
      <div className="col-lg-9 col-md-6 col-sm-12 search-filter__bar ">
        <SearchBar term={props.term} onChange={onChange} onEnter={onSubmit} />
      </div>
      <div className="col-lg-3 col-md-6 col-sm-12 search-filter__control">
        <Button text="Search" onClick={onSubmit} />
      </div>
    </div>
  );
};

export default SearchBarFilter;
